export const EVENT_CATEGORIES = {
    CLICK: "click",
    FILTER: "filter",
    DOWNLOAD: "download"
};
